// https://github.com/leoschmitz/validate_cpf_cnpj/blob/master/validate_cpf_cnpj.js

/**
 * Remove code formatting
 * @param {string} code Code
 * @returns {list} list of digits
 */
function getNumbers(code) {
  const numbers = []
  if (!code || code.length === 0) {
    return numbers
  }
  for (let i = 0; i < code.length; i++) {
    if (!isNaN(code[i])) {
      numbers.push(parseInt(code[i], 10))
    }
  }
  return numbers
}

/**
 * Get both CPF check digits.
 * @param {string} cpf CPF numbers only
 * @returns {list} digit 1 and 2
 */
function getCPFCheckDigits(cpf) {
  let digit1 = 0
  let digit2 = 0
  for (let i = 0; i < 9; i++) {
    digit1 = digit1 + cpf[i] * (10 - i)
    digit2 = digit2 + cpf[i] * (11 - i)
  }
  digit1 = digit1 % 11 > 1 ? 11 - (digit1 % 11) : 0
  digit2 = digit2 + digit1 * 2
  digit2 = digit2 % 11 > 1 ? 11 - (digit2 % 11) : 0
  return [digit1, digit2]
}

/**
 * Validates CPF (Cadastro de Pessoa Física)
 * @param {string} cpf CPF code, which can be formatted or not
 * @returns {bool} valid or invalid
 */
export function isCPF(cpf) {
  cpf = getNumbers(cpf)
  if (cpf.length !== 11) {
    return false
  }

  let checkdigits = getCPFCheckDigits(cpf)
  return checkdigits[0] === cpf[9] && checkdigits[1] === cpf[10]
}

/**
 * Get both CNPJ check digits.
 * @param {string} cnpj CNPJ numbers only
 * @returns {list} digit 1 and 2
 */
function getCNPJCheckDigits(cnpj) {
  let digit1 = 0
  let digit2 = 0
  for (let i = 0; i < 4; i++) {
    digit1 = digit1 + cnpj[i] * (5 - i)
    digit2 = digit2 + cnpj[i] * (6 - i)
  }
  digit2 = digit2 + cnpj[4] * 2
  for (let i = 0; i < 8; i++) {
    digit1 = digit1 + cnpj[i + 4] * (9 - i)
    digit2 = digit2 + cnpj[i + 5] * (9 - i)
  }
  digit1 = digit1 % 11 > 1 ? 11 - (digit1 % 11) : 0
  digit2 = digit2 % 11 > 1 ? 11 - (digit2 % 11) : 0
  return [digit1, digit2]
}

/**
 * Validate CNPJ.
 * @param {string} cnpj CNPJ code, which can be formatted or not
 * @returns {bool} valid or invalid
 */
export function isCNPJ(cnpj) {
  cnpj = getNumbers(cnpj)
  if (cnpj.length !== 14) {
    return false
  }

  let checkdigits = getCNPJCheckDigits(cnpj)
  return checkdigits[0] === cnpj[12] && checkdigits[1] === cnpj[13]
}

export const isCPForCNPJ = doc => isCPF(doc) || isCNPJ(doc)

export default { isCPForCNPJ, isCNPJ, isCPF }
